import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

// Helper function to retrieve the access token from storage
const getAccessToken = (): string | null => {
  try {
    // Configurações do Cognito (mesmos valores do index.tsx/apiClient.ts)
    const authority = 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_sgMHVAasC';
    const clientId = '142lurdgkn78inlb9qup85bsa0';
    const storageKey = `oidc.user:${authority}:${clientId}`;
    
    // Tenta obter do sessionStorage (padrão do oidc-client-ts)
    let userStr = sessionStorage.getItem(storageKey);
    
    // Se não encontrar, tenta localStorage (fallback)
    if (!userStr) {
      userStr = localStorage.getItem(storageKey);
    }

    if (userStr) {
      const user = JSON.parse(userStr);
      return user?.access_token || null;
    }
    
    // Fallback genérico: procura por qualquer chave oidc.user
    const storages = [sessionStorage, localStorage];
    for (const storage of storages) {
      for (let i = 0; i < storage.length; i++) {
        const key = storage.key(i);
        if (key?.startsWith('oidc.user:')) {
          const val = storage.getItem(key);
          if (val) {
            const user = JSON.parse(val);
            if (user?.access_token) return user.access_token;
          }
        }
      }
    }
  } catch (error) {
    console.error('Erro ao obter token do storage:', error);
  }
  return null;
};

class ApiClientService {
  private api: AxiosInstance;

  constructor(baseURL: string) {
    this.api = axios.create({
      baseURL
    });

    this.api.interceptors.request.use(
      async (config) => {
        const token = getAccessToken();
        if (process.env.NODE_ENV === 'development') {
          console.log("req: ", config?.url);
        }

        if (token && config.headers && !config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        console.log("erro busca", error);
        return Promise.reject(error);
      }
    );

    this.api.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response?.status === 401) {
          console.log('erro autenticação 401');
          // Opcional: Redirecionar para login ou limpar storage
          // window.location.href = '/';
        }
        return Promise.reject(error);
      }
    );
  }

  async get<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>
  ): Promise<R> {
    return this.api.get(url, config);
  }

  async post<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>
  ): Promise<R> {
    return this.api.post(url, data, config);
  }

  async put<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>
  ): Promise<R> {
    return this.api.put(url, data, config);
  }

  async delete<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>
  ): Promise<R> {
    return this.api.delete<T, R, D>(url, config);
  }
}

// URL base com fallback
console.log('API URL:', process.env.REACT_APP_API_URL);
const API_URL = process.env.REACT_APP_API_URL!;

// Exporta a instância
export default new ApiClientService(API_URL);

export const DropdownHttpClient = new ApiClientService(API_URL);